import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Aucun jeton à lire dans l'URL ici : le cookie de connexion partagé
// (Domain=.lafribue.fr) a déjà été posé par le backend avant cette
// redirection (cf. set_auth_cookie dans google_callback) - il suffit de
// relire /auth/me pour reconnaître la personne.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    checkAuth().then(() => navigate("/", { replace: true }));
  }, [checkAuth, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full border-2 border-[#FF007F] border-t-transparent animate-spin" />
        <p className="text-white/60 text-sm">Connexion en cours...</p>
      </div>
    </div>
  );
}
